import './App.css'
import './index.css'

export function Work() {
    return (
        <>
            <h1 className="title">Work</h1>
            <div className="nj-transit">
                <h2 className="heading">NJ TRANSIT</h2>
                <p>
                    During the summer of 2025, I had the privilege of interning at NJ TRANSIT on the Real Estate & GIS team.
                </p>
                <p>
                    Some professional accomplishments include:
                </p>
                <ul>
                    <li>• Mapped out 50+ NJ Transit parcels with corresponding deeds across New Jersey using ArcGIS Pro, building a comprehensive GIS database for real estate planning.</li>
                    <li>• Tracked ownership across 100+ linear miles of railroad right of way using valuation maps and geoprocessing tools like Split Line by Point and Select by Location. </li>
                    <li>• Wrote Python script automating the retrieval of missing deeds from county websites, downloading 100+ documents.</li>
                </ul>

                <p>
                    My work was foundational for the NJ TRANSIT's LAND plan, a plan to increase non-farebox revenue by redeveloping property that the agency owns across the state.
                </p>

                <p> See more info <a target='_blank' href="https://content.njtransit.com/sites/default/files/marketing/website/pdf/REAL_ESTATE_OPPORTUNITY_REPORT.pdf">here</a>.</p>
            </div>
        </>
    )
}